import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import {
  failureaddContentMobile,
  successaddContentMobile,
} from "./AddContentMobileSlice";
import { PayloadAction } from "@reduxjs/toolkit";
import { IContentMobile } from "../../../Pages/ContentMobile/IContentMobile";

import {
  failuredeleteContentMobile,
  successdeleteContentMobile,
} from "./DeleteContentMobileSlice";
import {
  failurelistContentMobile,
  successlistContentMobile,
} from "./ListContentMobileSlice";
import {
  failureEditContentMobile,
  successEditContentMobile,
} from "./EditContentMobileSlice";

// list
const ListContentMobileApi = () => {
  return api.get("/api/formula/content/get");
};

export function* ListContentMobileCall() {
  try {
    const response: AxiosResponse = yield call(ListContentMobileApi);
    yield put(successlistContentMobile(response.data));
  } catch (error) {
    yield put(failurelistContentMobile(error));
  }
}

// add
const AddContentMobileApi = (action: PayloadAction<IContentMobile>) => {
  return api.post("/api/formula/content/create", action.payload);
};

export function* AddContentMobileCall(action: PayloadAction<IContentMobile>) {
  try {
    const response: AxiosResponse = yield call(AddContentMobileApi, action);
    yield put(successaddContentMobile(response.data));
  } catch (error) {
    yield put(failureaddContentMobile(error));
  }
}

// edit
const EditContentMobileApi = (action: PayloadAction<IContentMobile>) => {
  return api.put("/api/formula/content/update", action.payload, {
    params: { id: action.payload.id },
  });
};

export function* EditContentMobileCall(action: PayloadAction<IContentMobile>) {
  try {
    const response: AxiosResponse = yield call(EditContentMobileApi, action);
    yield put(successEditContentMobile(response.data));
  } catch (error) {
    yield put(failureEditContentMobile(error));
  }
}

// delete
const DeleteContentMobileApi = (action: PayloadAction<number>) => {
  return api.delete("/api/formula/content/delete", {
    params: { id: action.payload },
  });
};

export function* DeleteContentMobileCall(action: PayloadAction<number>) {
  try {
    const response: AxiosResponse = yield call(DeleteContentMobileApi, action);
    yield put(successdeleteContentMobile(response.data));
  } catch (error) {
    yield put(failuredeleteContentMobile(error));
  }
}
